"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPrepDataSourceStatus = exports.isFlowpublishedSelector = exports.selectOutcomeListRecieved = exports.needsAuthSelector = exports.domainRetrievalStatusSelector = exports.selectOutcomeDomainError = exports.modelOutcomeListSelector = exports.subspaceSelector = exports.objectiveSelector = void 0;
var StateSelectorUtils_1 = require("../util/StateSelectorUtils");
var objectiveSelector = function (root) {
    return root.subspace.objective;
};
exports.objectiveSelector = objectiveSelector;
var subspaceSelector = function (root) {
    return root.subspace.subspace;
};
exports.subspaceSelector = subspaceSelector;
var modelOutcomeListSelector = function (root) {
    return root.subspace.outcomeList;
};
exports.modelOutcomeListSelector = modelOutcomeListSelector;
var selectOutcomeDomainError = function (root) {
    return root.subspace.outcomeDomainError;
};
exports.selectOutcomeDomainError = selectOutcomeDomainError;
var domainRetrievalStatusSelector = function (root) {
    return root.subspace.domainRetrievalStatus;
};
exports.domainRetrievalStatusSelector = domainRetrievalStatusSelector;
var needsAuthSelector = function (root) {
    return root.subspace.needsAuth;
};
exports.needsAuthSelector = needsAuthSelector;
var selectOutcomeListRecieved = function (root) {
    return root.subspace.outcomeList && root.subspace.outcomeList.length > 0;
};
exports.selectOutcomeListRecieved = selectOutcomeListRecieved;
var isFlowpublishedSelector = function (root) {
    return root.subspace.isFlowpublished;
};
exports.isFlowpublishedSelector = isFlowpublishedSelector;
var selectPrepDataSourceStatus = function (root) {
    return (0, StateSelectorUtils_1.getPrepDataSourceStatus)(root.subspace.isFlowpublished, root.subspace.outcomeList);
};
exports.selectPrepDataSourceStatus = selectPrepDataSourceStatus;
//# sourceMappingURL=StateSelectors.js.map